module.exports = __webpack_public_path__ + "static/media/fingerprint2.2b676fc6.svg";